import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Code2, Target, Users, Zap } from 'lucide-react';

const AboutPage = () => {
  const values = [
    {
      icon: Zap,
      title: 'Performance First',
      description: 'All our tools are optimized for speed and run client-side for instant results'
    },
    {
      icon: Users,
      title: 'Developer Focused',
      description: 'Built by developers, for developers. We understand your workflow'
    },
    {
      icon: Target,
      title: 'Privacy Matters',
      description: 'Your data never leaves your browser. Complete privacy guaranteed'
    },
    {
      icon: Code2,
      title: 'Always Free',
      description: 'All tools are completely free to use, no hidden costs or subscriptions'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="mb-12 text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">About DevTools Hub</h1>
          <p className="text-gray-600 dark:text-gray-300 text-lg max-w-3xl mx-auto">
            Your go-to platform for essential developer tools
          </p>
        </div>

        {/* Story Section */}
        <div className="max-w-4xl mx-auto mb-16">
          <Card className="border-gray-200 dark:border-gray-800">
            <CardContent className="pt-6">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Our Story</h2>
              <div className="space-y-4 text-gray-700 dark:text-gray-300">
                <p>
                  DevTools Hub was created out of frustration with slow, bloated developer tools scattered across the web. 
                  As developers, we needed fast, reliable, and private tools that just work.
                </p>
                <p>
                  That's why we built this platform - a collection of essential developer tools that run entirely in your 
                  browser, ensuring lightning-fast performance and complete privacy. No data ever leaves your machine.
                </p>
                <p>
                  Today, DevTools Hub serves thousands of developers worldwide, helping them work more efficiently with 
                  tools they can trust.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Values Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <Card key={index} className="border-gray-200 dark:border-gray-800 hover:shadow-xl transition-shadow">
                  <CardContent className="pt-6">
                    <div className="p-3 rounded-lg bg-gradient-to-br from-blue-100 to-cyan-100 dark:from-blue-900/30 dark:to-cyan-900/30 w-fit mb-4">
                      <Icon className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">{value.title}</h3>
                    <p className="text-gray-600 dark:text-gray-300">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Mission Section */}
        <div className="max-w-4xl mx-auto">
          <Card className="border-gray-200 dark:border-gray-800 bg-gradient-to-br from-blue-50 to-cyan-50 dark:from-blue-950 dark:to-cyan-950">
            <CardContent className="pt-6">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 text-center">Our Mission</h2>
              <p className="text-gray-700 dark:text-gray-300 text-lg text-center">
                To provide developers with the best free tools that respect their privacy, 
                work instantly, and help them build amazing things.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;